import { render, staticRenderFns } from "./CollectDispose.vue?vue&type=template&id=11b705a6&scoped=true&"
import script from "./CollectDispose.vue?vue&type=script&lang=js&"
export * from "./CollectDispose.vue?vue&type=script&lang=js&"
import style0 from "./CollectDispose.vue?vue&type=style&index=0&id=11b705a6&scoped=true&lang=scss&"
import style1 from "./CollectDispose.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b705a6",
  null
  
)

export default component.exports